import React from "react";
import { useSelector } from "react-redux";
import showdown from "showdown";
import classnames from "classnames";

export default () => {
  const currentActivity = useSelector((state) => state.activity);
  const converter = new showdown.Converter();
  const subtitle = converter.makeHtml(
    currentActivity.websiteData.reasons.subtitle
  );

  return (
    currentActivity &&
    currentActivity.websiteData &&
    currentActivity.websiteData.reasons &&
    currentActivity.websiteData.reasons.data &&
    currentActivity.websiteData.reasons.data.length > 0 && (
      <div
        id="features"
        className="gradiant-background pwg-section features-section section"
      >
        <div className="container tab-fix">
          <div className="section-head heading-light text-center">
            <div className="row">
              <div className="col-md-8 col-md-offset-2">
                <h2 className="heading heading-light">
                  {currentActivity.websiteData.reasons.title
                    ? currentActivity.websiteData.reasons.title
                    : "Reasons"}
                </h2>
                {currentActivity.websiteData.reasons.subtitle && (
                  <p
                    className="h4 heading-light"
                    dangerouslySetInnerHTML={{ __html: subtitle }}
                  />
                )}
              </div>
            </div>
          </div>

          <div className="features-content pt-20">
            <div
              //className="row"
              style={{ display: "flex", flexWrap: "wrap" }}
            >
              {currentActivity.websiteData.reasons.data
                .filter((elm) => elm !== null)
                .map((reason) => {
                  const title = converter.makeHtml(reason.title);
                  const description = converter.makeHtml(reason.description);
                  return (
                    <div
                      className={classnames(
                        {
                          "col-md-6 col-sm-12":
                            currentActivity.websiteData.reasons.data.length %
                              2 ===
                            0,
                        },
                        {
                          "col-md-4 col-sm-12":
                            currentActivity.websiteData.reasons.data.length %
                              2 !==
                            0,
                        }
                      )}
                      data-wow-duration=".5s"
                      data-wow-delay=".3s"
                    >
                      <div className="features-list tab-left mobile-left">
                        <div className="icon-left wow fadeIn">
                          <div
                            className="d-flex mb-3"
                            style={{ justifyContent: "start" }}
                          >
                            <div
                              className="d-flex"
                              style={{ alignItems: "center" }}
                            >
                              <img
                                className="mr-3"
                                style={{ width: 50 }}
                                src={reason.icon}
                                alt="icon"
                              ></img>
                              <h4
                                // style={{ color: "white" }}
                                className="text-center heading-light"
                                dangerouslySetInnerHTML={{
                                  __html: title,
                                }}
                              ></h4>
                            </div>
                          </div>
                          <p
                            className="text-center text-justify mb-9 heading-light"
                            // style={{ color: "white" }}
                            dangerouslySetInnerHTML={{
                              __html: description,
                            }}
                          ></p>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    )
  );
};
